import styled from 'styled-components';

const SwitchField = styled.div`
  display: flex;
  align-items: center;

  [role='switch'] {
    vertical-align: middle;
    margin-left: 8px;
  }
`;

export default SwitchField;
